import React from "react";
import { X } from "lucide-react";

export function VideoModal({ showVideo, setShowVideo }) {
  if (!showVideo) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
      onClick={() => setShowVideo(false)}
    >
      <div className="relative max-w-4xl w-full">
        <button
          onClick={() => setShowVideo(false)}
          className="absolute -top-12 right-0 text-white hover:text-[#39FF14]"
        >
          <X className="w-8 h-8" />
        </button>
        <div className="aspect-video bg-gray-800 rounded-xl flex items-center justify-center">
          <p className="text-gray-400">Demo video placeholder - Add your video URL here</p>
        </div>
      </div>
    </div>
  );
}
